import React, { useEffect, useRef, useState } from "react";
// import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import SelectReact from "../../../components/Select/SelectReact";
import { languageHelper } from "../../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

function AddOutletForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [orderType, setOrderType] = useState([]);
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    city_id: "",
    status: "",
    user_id: user?.user.id,
    registration_no: "42101",
    order_type: [],
  });

  const autocompleteRef = useRef();

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCitySelect = (e) => {
    setFormData({
      ...formData,
      city_id: e.value,
    });
  };

  const handleCheck = (e) => {
    const { value, checked } = e.target;
    setFormData((prevFormData) => {
      let updatedOrderType;
      if (checked) {
        // Add to the list
        updatedOrderType = [
          ...prevFormData.order_type,
          { ordertype_id: value },
        ];
      } else {
        // Remove from the list
        updatedOrderType = prevFormData.order_type.filter(
          // eslint-disable-next-line eqeqeq
          (item) => item.ordertype_id != value
        );
      }
      return {
        ...prevFormData,
        order_type: updatedOrderType,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!id) {
      // After getting CSRF token, make the logout request

      axios
        .post(`${apiKey}/api/rms/admin/add-outlet`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setLoading(false);
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
          setLoading(false);
        });
    } else {
      // After getting CSRF token, make the logout request
      axios
        .put(`${apiKey}/api/rms/admin/update-outlet/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setLoading(false);
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      // After getting CSRF token, make the logout request
      axios
        .get(`${apiKey}/api/rms/admin/get-outlets/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          let data = res.data[0];

          data = {
            ...data,
            order_type: res.data[0].order_type.map((type) => ({
              ordertype_id: type.id,
            })),
          };
          setFormData(data);

          setPageLoading(false);
        })
        .catch((err) => {
          setPageLoading(false);
          // setError(err.response.data.message);
        });
    }
  }, [id, user?.token]);

  useEffect(() => {
    const fetchCities = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/admin/cities`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchOrderType = (csrfToken) => {
      return axios.get(`${apiKey}/api/rms/customer/get-order-type`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
    };

    const fetchData = (csrfToken) => {
      Promise.all([fetchCities(csrfToken), fetchOrderType(csrfToken)])
        .then(([citiesResponse, orderTypeResponse]) => {
          const mappedCities = citiesResponse.data.map((item) => ({
            value: item.city_id,
            label: item.name_en,
          }));
          setCities(mappedCities);
          setOrderType(orderTypeResponse.data);
        })
        .catch((err) => {
          console.error(err);
        });
    };

    handleCSRF(fetchData);
  }, [user?.token]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAtJKFDkcrxiT0JAz24WgBKInU6AZL55RE&libraries=places`;
    script.async = true;
    script.onload = () => {
      const autocomplete = new window.google.maps.places.Autocomplete(
        autocompleteRef.current,
        {
          componentRestrictions: { country: "SA" },
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        setFormData((prevData) => ({
          ...prevData,
          address: place.formatted_address || "", // Update location with the selected address
        }));
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Outlet")}
            </h1>
          </div>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-x-8 gap-y-4">
              <label htmlFor="" className="w-full ">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Outlet Code")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="000001"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="code"
                    value={formData.code}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full ">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Outlet Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Outlet Name")}
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Phone")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Phone")}
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full ">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  {languageHelper("Email")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder={languageHelper("Email")}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("Address")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    ref={autocompleteRef}
                    value={formData.address}
                    onChange={handleChange}
                    name="address"
                    placeholder={languageHelper("Address")}
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    id="autocomplete"
                    required
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  {languageHelper("City")}
                </span>
                <div className="mb-2 pt-0">
                  <SelectReact options={cities} onChange={handleCitySelect} />
                </div>
              </label>

              <label htmlFor="" className="w-full flex flex-col">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold w-fit">
                  {languageHelper("Order Type")}
                </span>
                {orderType.map((type, index) => (
                  <div key={index} className="inline-flex items-center">
                    <label
                      className="relative flex items-center p-3 rounded-full cursor-pointer"
                      htmlFor={type.name}
                    >
                      <input
                        type="checkbox"
                        className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-[#7B20C7] checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
                        id={type.name}
                        value={type.id}
                        onChange={handleCheck}
                        checked={formData.order_type?.some((selected) => {
                          // eslint-disable-next-line eqeqeq
                          return type.id == selected.ordertype_id;
                        })}
                      />
                      <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-3.5 w-3.5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          stroke="currentColor"
                          strokeWidth="1"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clipRule="evenodd"
                          ></path>
                        </svg>
                      </span>
                    </label>
                    {defaultLang === "text_en"
                      ? type.name
                      : type.name_arabic || type.name}
                  </div>
                ))}
              </label>

              <label htmlFor="" className="w-full ">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  {languageHelper("Active Status")}
                </span>
                <div className="mb-2 pt-0">
                  <select
                    name="status"
                    id=""
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    onChange={handleChange}
                  >
                    <option></option>
                    <option
                      value={"active"}
                      selected={formData.status === "active"}
                    >
                      {languageHelper("Active")}
                    </option>
                    <option
                      value={"inactive"}
                      selected={formData.status === "inactive"}
                    >
                      {languageHelper("In-Active")}
                    </option>
                  </select>
                </div>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}
    </main>
  );
}

export default AddOutletForm;
